export default __webpack_public_path__ + "fonts/avant-garde-400i.woff";